import { useFormContext } from 'react-hook-form';

import { type QConfigSettingsFormInput } from './qconfig-settings-form-schema';

export const useQConfigSettingsFormContext = useFormContext<QConfigSettingsFormInput>;
